import { History } from 'lucide-react';

import { DESCRICOES_ORIGEM, type OrigemSolicitacao } from '@/features/solicitacoes/origem';
import { cn } from '@/lib/utils';

interface BadgeOrigemProps {
  origem: OrigemSolicitacao;
  tamanho?: 'sm' | 'md';
  className?: string;
}

/**
 * Marca a solicitação que veio do estoque anterior ao KAVI.
 *
 * **Só aparece na demanda reprimida.** O selo existe para sinalizar a exceção;
 * etiquetar também a solicitação da UBS encheria a fila inteira de rótulo e
 * apagaria justamente a distinção que ele serve para fazer.
 *
 * **Tom neutro, e não cor de status.** Os outros selos da fila — documento
 * novo, dados corrigidos, cancelamento pedido — são coloridos porque significam
 * "alguém precisa agir agora". Origem é um fato sobre o registro, não um
 * chamado; tomar a cor deles enfraqueceria os três.
 */
export function BadgeOrigem({ origem, tamanho = 'md', className }: BadgeOrigemProps) {
  if (origem !== 'DEMANDA_REPRIMIDA') return null;

  const descricao = DESCRICOES_ORIGEM.DEMANDA_REPRIMIDA;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        'bg-silenciado text-silenciado-texto border-borda',
        tamanho === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className,
      )}
      title={descricao}
    >
      <History
        className={tamanho === 'sm' ? 'size-3' : 'size-3.5'}
        aria-hidden="true"
        strokeWidth={2.25}
      />
      <span>Demanda reprimida</span>
      <span className="apenas-leitor-tela">. {descricao}</span>
    </span>
  );
}
